import { defineComponent as _defineComponent } from 'vue'
import CreateAccountPage from './CreateAccountPage.vue';
import ForgotPasswordPage from './ForgotPasswordPage.vue';
import SignInPage from './SignInPage.vue';
import { delay } from 'JS/utilities/promise';
import { LoginPageType } from 'JS/types/Account';
import { objectToQueryString } from 'JS/utilities/url';
import { onMounted, ref } from 'vue';
import { serviceRegistry } from '../../composables/services';


export default /*#__PURE__*/_defineComponent({
  __name: 'LoginSideMenuContents',
  props: {
    page: null,
    skipCartMerge: { type: Boolean },
    isFullScreenVersion: { type: Boolean }
  },
  emits: ["go-to-rewards", "loading", "update-side-menu-header-button", "update:page", "signed-in"],
  setup(__props: any, { emit }: { emit: ({
	(event: 'go-to-rewards'): void;
	(event: 'loading', value: boolean): void;
	(event: 'update-side-menu-header-button', returnPage: LoginPageType | 'clear'): void
	(event: 'update:page', value: string)
	(event: 'signed-in', isRewardsMember: boolean): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
	page: LoginPageType,
	skipCartMerge?: boolean,
	isFullScreenVersion?: boolean,
}

//Imports




const { getAntiForgeryToken } = serviceRegistry;

const showCaptcha = ref<boolean>(false);
const currentEmail = ref<string>('');
const antiForgeryToken = ref<string>('');

function changePage(page: LoginPageType) {
	emit('update-side-menu-header-button', page === 'forgot-password' ? 'login' : 'clear');
	emit('update:page', page);
}

function handleSignedIn(isRewardsMember: boolean) {
	window?.vueEventBus?.$emit('blain-login-success');
	emit('signed-in', isRewardsMember);
}

onMounted(async ()=> {
	emit('loading', true);
	antiForgeryToken.value = await delay(getAntiForgeryToken(), 400);
	if (!window.location.pathname.includes('login') && !antiForgeryToken.value) {
		window.location.href = `/account/login/?${objectToQueryString({
			refUrl: window?.location.pathname,
			create: props.page === 'create' ? '1' : '0'
		})}`;
	} else {
		emit('loading', false);
	}
});


return { __sfc: true,props, emit, getAntiForgeryToken, showCaptcha, currentEmail, antiForgeryToken, changePage, handleSignedIn, CreateAccountPage, ForgotPasswordPage, SignInPage }
}

})